import { Condition } from '@staffino/model';
import { ConditionEvaluatorContext } from '../condition-evaluator-context';

export default async function target(
  condition: Condition,
  context: ConditionEvaluatorContext,
): Promise<boolean> {
  const { operator } = condition[1] ?? {};
  const targetId = context.stateManager.getTargetId();

  if (operator === 'empty') {
    return !targetId;
  }
  if (operator === '!empty') {
    return !!targetId;
  }
  return false;
}
